import { useState, useRef } from "react";
import { Play } from "lucide-react";

const SPORT_GRADIENTS = {
  Pickleball: "from-emerald-900 to-emerald-700",
  Padel: "from-blue-900 to-blue-700",
  Cricket: "from-amber-900 to-amber-700",
  Football: "from-red-900 to-red-700",
  Badminton: "from-purple-900 to-purple-700",
};

export default function VideoThumbnail({ src, alt, sport, className }) {
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(false);

  const gradient = SPORT_GRADIENTS[sport] || "from-slate-900 to-slate-700";
  const isVideo = src && src.match(/\.(mp4|webm|mov)(\?|$)/i);

  return (
    <div className={`relative ${className}`}>
      {/* Sport-colored gradient fallback (always rendered behind) */}
      <div className={`absolute inset-0 bg-gradient-to-br ${gradient} flex items-center justify-center`}>
        <div className="text-center">
          <Play className="w-10 h-10 text-white/40 mx-auto mb-1" />
          <span className="text-white/30 text-xs font-bold uppercase tracking-widest">{sport}</span>
        </div>
      </div>

      {/* Video first-frame (will overlay gradient when loaded) */}
      {isVideo && !error && (
        <video
          src={`${src}#t=1`}
          muted
          playsInline
          preload="metadata"
          className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-500 ${
            loaded ? "opacity-100" : "opacity-0"
          }`}
          onLoadedData={() => setLoaded(true)}
          onError={() => setError(true)}
          data-testid="video-thumbnail"
        />
      )}

      {/* Image fallback */}
      {src && !isVideo && !error && (
        <img
          src={src}
          alt={alt}
          className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-500 ${
            loaded ? "opacity-100" : "opacity-0"
          }`}
          onLoad={() => setLoaded(true)}
          onError={() => setError(true)}
        />
      )}
    </div>
  );
}
